module.exports = __webpack_public_path__ + "img/asia-flag.11a310f8.svg";